<!--
 * @Author: your name
 * @Date: 2020-10-14 17:27:26
 * @LastEditTime: 2024-12-24 12:00:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/PrivacyDialog/index.vue
-->
<style lang="sass" scoped>
.terms_dialog
  height: 90vh
  width: 90vw
  position: fixed
  top: 5vh
  left: 5vw
  z-index: 4
  overflow-y: auto
  padding: 24px
  background: #fff
  border-radius: 10px
  box-sizing: border-box

.origin_terms_dialog
  height: 0
  width: 0
  position: fixed
  top: 5vh
  left: 5vw
  z-index: 4
  overflow: hidden
  background: #fff
  border-radius: 10px

.white
  position: fixed
  height: 100%
  width: 100%
  top: 0
  z-index: 3
  background: rgba(0,0,0,0.5)
  transition: background .5s ease

.origin
  position: fixed
  height: 100%
  width: 100%
  top: 0
  background: rgba(0,0,0,0)
  transition: background .5s ease

.close
  height: 40px
  width: 40px
  display: flex
  justify-content: center
  align-items: center
  position: absolute
  top: 0
  right: 0
  z-index: 4
  border-radius: 50%

.privacy_content
  color: #1f1f1f
  font-size: 14px
  line-height: 1.6

  h1
    margin: 0 0 16px
    font-size: 24px
    color: #222

  h2
    margin: 24px 0 8px
    font-size: 18px
    color: #222

  h3
    margin: 16px 0 8px
    font-size: 16px
    color: #222

  p
    margin: 0 0 12px

  ul, ol
    margin: 0 0 16px 20px
    padding: 0

  ul ul, ol ul
    margin: 8px 0 8px 20px

  li
    list-style: disc

  strong
    font-weight: 700

  em
    font-style: italic

  a
    color: #1155cc
    text-decoration: underline
</style>
<template>
  <div :class="{'origin': !showPrivacyDialog, 'white': showPrivacyDialog}">
    <div :class="{'origin_terms_dialog': !showPrivacyDialog, 'terms_dialog': showPrivacyDialog}">
      <div class="privacy_content">
        <h1>MondoConneX Privacy Policy (Australia &amp; New Zealand)</h1>

        <h2>1. Introduction</h2>
        <p>MondoConneX Pty Ltd (we, us, our) is committed to protecting your privacy. We provide digital ordering solutions, including QR code ordering, self-service kiosks, and mobile point-of-sale systems for the hospitality industry.</p>
        <p>This Privacy Policy explains how we collect, use, and protect your personal information in accordance with:</p>
        <ul>
          <li><strong>Australia:</strong> The <em>Privacy Act 1988</em> (Cth) and the Australian Privacy Principles (<strong>APPs</strong>).</li>
          <li><strong>New Zealand:</strong> The <em>Privacy Act 2020</em> (NZ) and the Information Privacy Principles (<strong>IPPs</strong>).</li>
          <li><strong>International:</strong> Where applicable, the General Data Protection Regulation (EU) 2016/679 (<strong>GDPR</strong>).</li>
        </ul>

        <h2>2. Scope of this Policy</h2>
        <p>This policy applies to personal information collected through:</p>
        <ul>
          <li><strong>The Platforms:</strong> Our websites, mobile applications, QR code web-apps, and <strong>Self-Service Kiosks</strong>.</li>
          <li><strong>Mondo PocketPOS:</strong> Our mobile handheld ordering and payment devices operated by venue staff.</li>
          <li><strong>Mondo Menu:</strong> Our ordering and menu management system.</li>
          <li><strong>Services:</strong> Technical support, integrations (including Oracle POS), and consulting services.</li>
        </ul>

        <h2>3. What Information We Collect</h2>
        <p>We practice "data minimisation" and only collect what is necessary to facilitate your order and improve our services.</p>

        <h3>A. Information you give us</h3>
        <p>When you place an order via a QR code, Kiosk, or interact with a staff member using PocketPOS, we may collect:</p>
        <ul>
          <li><strong>Identity Data:</strong> Name, email address, phone number (e.g., for digital receipts).</li>
          <li><strong>Transaction Data:</strong> Details of the venue visited, items ordered, time of transaction, and table/seat number.</li>
          <li><strong>Feedback:</strong> Responses to surveys or experience ratings.</li>
        </ul>

        <h3>B. Information we collect automatically</h3>
        <ul>
          <li><strong>Device Data:</strong> IP address, browser type, device type (e.g., iPhone or Android), and operating system.</li>
          <li><strong>Usage Data:</strong> We log system interaction data to monitor hardware performance, uptime, and application stability.</li>
        </ul>

        <h3>C. Financial Information</h3>
        <p>We <strong>do not</strong> store your full credit card numbers on our servers.</p>
        <ul>
          <li><strong>Online/QR Orders:</strong> We use secure third-party payment gateways (including <strong>Fiserv</strong> and <strong>Square</strong>) to process payments.</li>
          <li><strong>Kiosk &amp; PocketPOS:</strong> For in-person payments, we utilise secure terminals and SDKs (such as the <strong>Square Mobile SDK</strong>) to process "card-present" transactions.</li>
          <li>We may store a "token" (an encrypted reference) or masked card details (e.g., last 4 digits) to allow for refunds or troubleshooting, strictly in accordance with PCI-DSS standards.</li>
        </ul>

        <h2>4. How We Use Your Information</h2>
        <p>We use your data for the following specific purposes:</p>
        <ul>
          <li><strong>Fulfilment:</strong> To transmit your order to the venue's kitchen/POS system (e.g., Oracle Simphony) and issue receipts.</li>
          <li><strong>Support &amp; Maintenance:</strong> To troubleshoot failed orders, connectivity issues, or integration errors.</li>
          <li><strong>Communication:</strong> To send you status updates regarding your order.</li>
          <li><strong>Marketing (With Consent):</strong> To send offers or promotions <em>only</em> if you have actively opted-in.</li>
          <li><strong>Compliance:</strong> To meet legal obligations (e.g., tax records).</li>
        </ul>

        <h2>5. Disclosure of Your Information</h2>
        <p>We do not sell your personal information. We may share your information with:</p>
        <ul>
          <li><strong>The Venue:</strong> The specific restaurant, airport lounge, or hospitality group (e.g., SSP, ARE) where you placed your order. They require this data to fulfil your meal and for their own record-keeping.</li>
          <li><strong>Service Providers:</strong> Third-party partners who help us operate, including:
            <ul>
              <li>Cloud hosting providers (AWS).</li>
              <li>Payment Gateways (Fiserv, Square).</li>
              <li>POS Integrators (Oracle).</li>
            </ul>
          </li>
          <li><strong>Legal Requirements:</strong> If required by law, court order, or to protect the safety of our users.</li>
        </ul>

        <h2>6. International Data Transfers &amp; Storage</h2>
        <ul>
          <li><strong>Data Storage:</strong> Our production servers and customer databases are primarily hosted in <strong>Australia (AWS Sydney)</strong>.</li>
          <li><strong>New Zealand Customers:</strong> If you are located in New Zealand, you acknowledge that your personal information will be transferred to Australia for processing. We ensure this transfer is secure and that your information remains protected by laws comparable to the <em>Privacy Act 2020 (NZ)</em>.</li>
          <li><strong>Development:</strong> While we utilise development teams located overseas (including in China), strict access controls are in place. <strong>Offshore development teams do not have access to production customer databases or personal information.</strong> Only authorised onshore (Australian) staff have access to production data.</li>
        </ul>

        <h2>7. Data Retention and Security</h2>
        <ul>
          <li><strong>Security:</strong> We use industry-standard encryption (HTTPS/TLS) for data in transit and encryption for data at rest where appropriate.</li>
          <li><strong>Retention:</strong> We retain personal information only for as long as necessary to fulfil the purposes outlined in this policy or to comply with legal (tax/audit) requirements.
            <ul>
              <li><em>User Accounts:</em> Can be deleted upon request.</li>
              <li><em>Transaction Logs:</em> Retained for 7 years for tax and audit compliance, after which they are anonymised or destroyed.</li>
            </ul>
          </li>
        </ul>

        <h2>8. Your Rights</h2>
        <p>Depending on your location, you have rights regarding your data:</p>
        <ul>
          <li><strong>Access &amp; Correction:</strong> You can request a copy of the data we hold about you or ask us to fix errors.</li>
          <li><strong>Deletion (Right to be Forgotten):</strong> You may request that we delete your personal data, subject to our legal obligations to retain transaction records.</li>
          <li><strong>Opt-Out:</strong> You can unsubscribe from marketing emails at any time using the "Unsubscribe" link.</li>
        </ul>

        <h2>9. Cookies and Tracking</h2>
        <p>We use cookies to ensure our QR web-apps and Kiosks function correctly (e.g., remembering your basket contents). You can control cookies through your browser settings, though this may affect your ability to order.</p>

        <h2>10. Changes to This Policy</h2>
        <p>We will not make changes to this policy that materially affect your rights without notice.</p>
        <ul>
          <li><strong>Notification:</strong> If we make significant changes, we will notify you via a prominent notice on our Platforms or via email (if you hold an account).</li>
          <li><strong>Effective Date:</strong> Changes will apply 7 days after notification, giving you time to review the new terms. Continued use of our services after this period implies acceptance.</li>
        </ul>

        <h2>11. Contact Us &amp; Complaints</h2>
        <p>If you have questions about this policy or wish to exercise your data rights, please contact our Privacy Officer:</p>
        <ul>
          <li><strong>Email:</strong> privacy@mondoconnex.com</li>
          <li><strong>Phone:</strong> +61 3 9067 5638</li>
        </ul>

        <p><strong>Complaints</strong></p>
        <p>If you are not satisfied with our response to your privacy complaint, you may contact the relevant regulator:</p>
        <ul>
          <li><strong>Australia:</strong> Office of the Australian Information Commissioner (OAIC) – <a href="http://www.oaic.gov.au">www.oaic.gov.au</a></li>
          <li><strong>New Zealand:</strong> Office of the Privacy Commissioner (OPC) – <a href="http://www.privacy.org.nz">www.privacy.org.nz</a></li>
        </ul>
      </div>
    </div>
    <div class="close" @click="close">
      <icon size="30" color="#fff">clear</icon>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    showPrivacyDialog: Boolean
  }
})
class PrivacyDialog extends Vue {
  close() {
    this.$emit('update:showPrivacyDialog', false)
  }
}

export default PrivacyDialog
</script>
